"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NonceManager = void 0;
// NonceManager handle independent non-blocking UserOp transactions
class NonceManager {
    constructor() {
        this._nonceKey = -1;
        this.increment = () => {
            this._nonceKey += 1;
        };
        this.retrieve = () => {
            return this._nonceKey;
        };
    }
}
exports.NonceManager = NonceManager;
